import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Article/topic/feature ids are intentionally opaque strings that contain
// dots (e.g. "invoices.statuses", "plan-limit.invoices.issued.monthly") —
// not nested i18next key paths. i18next's `t()` treats every dot in a key as
// a path separator (`deepFind`), so `t('articles.invoices.statuses')` does
// not reliably resolve a flat `articles['invoices.statuses']` entry once the
// id itself has more than one segment. Content lookups keyed by an id read
// the raw resource bundle directly (plain object indexing) instead; `t()`
// stays fine for everything else (fixed key paths, interpolation).
export const useHelpBundle = () => {
  const { i18n } = useTranslation('help');
  return useMemo(
    () => i18n.getResourceBundle(i18n.language, 'help') || i18n.getResourceBundle('en', 'help') || {},
    [i18n],
  );
};

export default useHelpBundle;
